// Each contact line is allowed a maximum of 3 link items
export const LINK_LENGTH_LIMIT = 3

export const MIN_AVATAR_SIZE = 48
export const MAX_AVATAR_SIZE = 128

export const MIN_IMAGE_SIZE = 20
export const MAX_IMAGE_SIZE = 100

export const MIN_IMAGE_BR = 0
export const MAX_IMAGE_BR = 48

// Widget node margin range
export const MIN_MARGIN_VAL = 0
export const MAX_MARGIN_VAL = 64
